export default "__VITE_ASSET__edf8ac9c__"